import React, { useState } from 'react';
import { resetPasswordWithToken } from '../../api/moduleApi';

const ResetPassword = ({ token }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!password) {
      setError('Password is required.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await resetPasswordWithToken(token, password);
      setSuccess('Password updated successfully. You can now return to the login page and sign in.');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message || 'Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-start pt-20 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-xl">
        <h2 className="text-3xl font-extrabold text-indigo-800 mb-6 border-b-2 border-indigo-100 pb-3 text-center">Reset Password</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="new-password" className="text-sm font-medium text-gray-700">New password</label>
            <input
              id="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="new-password"
              required
              className="w-full mt-1 p-2 border rounded-lg"
            />
          </div>

          <div>
            <label htmlFor="confirm-password" className="text-sm font-medium text-gray-700">Confirm new password</label>
            <input
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              autoComplete="new-password"
              required
              className="w-full mt-1 p-2 border rounded-lg"
            />
          </div>

          {error && <div role="alert" aria-live="assertive" className="text-sm text-red-600">{error}</div>}
          {success && <div className="text-sm text-green-700">{success}</div>}

          <div className="flex items-center justify-between">
            <button
              disabled={loading}
              type="submit"
              className="py-2 px-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg"
            >
              {loading ? 'Saving...' : 'Update password'}
            </button>
            <a href="/" className="text-sm text-indigo-600 hover:underline">Back to login</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
